import React from 'react';
import { Form } from 'react-bootstrap';

class ZipcodeInput extends React.Component {
  
  renderZipcodeInput(props) {
    let result;
    result = (
      <Form.Group controlId="formZipcode">
        <Form.Label>Zipcode</Form.Label>
        <Form.Control size="sm" type="text" {...props}/>
      </Form.Group>
    );
    return result;
  }

  render() {
    return this.renderZipcodeInput(this.props);
  }
}


export default ZipcodeInput;

